











































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import * as M from 'materialize-css';

@Component
export default class Navbar extends Vue {

    @Prop(String)
    public readonly backgroundColor!: string;

    private showMenu = false;

    public mounted() {
        M.AutoInit();
    }

    public toggleMenu() {
        if (!this.showMenu) {
            this.showMenu = true;
        } else {
            this.showMenu = false;
        }
    }
}
